<div class="chart-wrapper" *ngIf="hasData">
    <canvas class="desktop-chart" width="100%" height="100%" baseChart [datasets]="chartData"  #chart [labels]="chartLabels" 
        [options]="chartOptions" [legend]="false" [type]="'doughnut'">
    </canvas>

</div>